import React from "react";
import InspectorPage from "./pages/InspectorPage";
import "./styles/inspector.scss";

export default function Inspector() {
  return <InspectorPage />;
}
